import instance from '../../config/axiosConfig';
export const UPDATE_EXIT_COUNT = 'UPDATE_EXIT_COUNT';

export const updateExitCount = (count) => ({
  type: UPDATE_EXIT_COUNT,
  payload: count
});

export const fetchExitCount = () => {
  return async (dispatch) => {
    try {
      const { data } = await instance.get(
        `/exit-request/pending?companyId=${localStorage.getItem('CompaneyId')}`
      );
      if (data && data.length > 0) {
        dispatch(updateExitCount(data.length));
      } else {
        dispatch(updateExitCount(0));
      }
    } catch (error) {
      console.log(error);
      dispatch(updateExitCount(0));
    }
  };
};
